import React, { useState, useEffect } from "react";

import './Articles.css'
import articleImg from "../../assets/specialists/Andrea_2.png"
export default function Articles() {
    return (
        <>
            <section className="articles-section section-green">
                <div className="container">
                    <div className="container-articles">
                        <div>
                          <h2 className="title" style={{ color: 'white' }}>Artículos Recientes</h2>
                        </div>
                       {/* GRID DE CARDS */}
                        <div className="articles-grid">
                            {[1, 2, 3, 4].map((item) => (
                                <div className="article-card" key={item}>
                                    <img src={articleImg} alt="Artículo" />
                                    <p className="description ">
                                        Suspendisse potenti. Sed tincidunt varius arcu. Mauris vitae arcu sit amet quam condimentum pulvinar.
                                    </p>
                                    <a href="/">Seguir leyendo</a>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};


